var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 380 380",
    style: {
      enableBackground: "new 0 0 380 380"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190,0C85.233,0,0,85.233,0,190s85.233,190,190,190s190-85.233,190-190S294.767,0,190,0z M190,340 c-82.71,0-150-67.29-150-150S107.29,40,190,40s150,67.29,150,150S272.71,340,190,340z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.993,184.132h-74.197c-2.696-4.393-6.403-8.1-10.796-10.796V84.139c0-9.389-7.611-17-17-17c-9.389,0-17,7.611-17,17 v89.197c-9.345,5.737-15.593,16.05-15.593,27.796c0,17.972,14.622,32.593,32.593,32.593c11.746,0,22.059-6.248,27.796-15.593 h74.197c9.389,0,17-7.611,17-17C308.993,191.743,301.382,184.132,291.993,184.132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d43f82ee4a32f4804ae228d588d2eb36.svg";
export { ForwardRef as ReactComponent };